<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc" role="doc-toc">
<h1 class="SOM_titre" epub:type="title">CONTENTS</h1>
<div class="SOM_chap"><a href="#/chap1"><span class="mev9">  1</span> The Starting Line: The Journey Begins</a></div>
<div class="SOM_chap"><a href="#/chap2"><span class="mev9">  2</span> The Color Line: Healing Racial Trauma</a></div>
<div class="SOM_chap"><span href="#/chap3" title="Link target outside of Sample"><span class="mev9">  3</span> The Family Line: Wounds and Wonder</span></div>
<div class="SOM_chap"><span href="#/chap4" title="Link target outside of Sample"><span class="mev9">  4</span> Fall in Line: The Mask</span></div>
<div class="SOM_chap"><span href="#/chap5" title="Link target outside of Sample"><span class="mev9">  5</span> Between the Lines: Things Lost and Found</span></div>
<div class="SOM_chap"><span href="#/chap6" title="Link target outside of Sample"><span class="mev9">  6</span> Out of Line: A Moral Injury</span></div>
<div class="SOM_chap"><span href="#/chap7" title="Link target outside of Sample"><span class="mev9">  7</span> A Fault Line: All In or Out</span></div>
<div class="SOM_chap"><span href="#/chap8" title="Link target outside of Sample"><span class="mev9">  8</span> The Frontline: Activism and Discipleship</span></div>
<div class="SOM_chap"><span href="#/chap9" title="Link target outside of Sample"><span class="mev9">  9</span> Hold the Line: The Long Wait</span></div>
<div class="SOM_chap"><span href="#/chap10" title="Link target outside of Sample"><span class="mev9">10</span> The Boundary Line: Where I End and You Begin</span></div>
<div class="SOM_chap"><span href="#/chap11" title="Link target outside of Sample"><span class="mev9">11</span> Walk the Line: What Matters Most</span></div>
<div class="SOM_chap"><span href="#/chap12" title="Link target outside of Sample"><span class="mev9">12</span> Finish Lines: Surrender and Acceptance</span></div>
<div class="SOM_appen"><span href="#/appen2" title="Link target outside of Sample">Acknowledgments</span></div>
<div class="SOM_appen"><span href="#/appen3" title="Link target outside of Sample">Appendix 1: The Genogram</span></div>
<div class="SOM_appen"><span href="#/appen4" title="Link target outside of Sample">Appendix 2: A Forgiveness Prayer</span></div>
<div class="SOM_appen"><span href="#/appen5" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/appen7" title="Link target outside of Sample">Praise for <i>Young, Gifted, and Black</i></span></div>
<div class="SOM_appen"><span href="#/appen8" title="Link target outside of Sample">About the Author</span></div>
<div class="SOM_pdf"><span href="#/fin_acheve" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?99eadef4